class AddMultipleProductsTable {
  hiddenClass = 'twcss-hidden';
  constructor() {
    this.productFormContainers = document.querySelectorAll('product-form');
    this.submitButton = document.querySelector('#select-multiple-submit');
    this.qtyBubble = document.querySelector('.cart-count-bubble');
    this.successMessage = document.querySelector(
      '#multiple-added-success-message',
    );
    this.changeHandlers();
  }
  changeHandlers() {
    this.submitButton.addEventListener('click', this.submit.bind(this));
  }

  submit() {
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    const items = [];
    this.productFormContainers.forEach((productFormContainer) => {
      const formData = new FormData(productFormContainer.form);
      const rawQuantity = parseInt(formData.get('quantity'), 10) || 0;

      // Zero here means "not ordering this row" (FR-007) and must never be
      // raised to an increment — unlike product-form.js's own row-submit
      // button, where a lingering 0 is a default rather than a customer
      // choice. Skip the row entirely rather than posting quantity: "0".
      if (rawQuantity === 0) return;

      const quantityInput = document.querySelector(
        `[form="${productFormContainer.form.id}"][name="quantity"]`,
      );
      const increment = quantityInput
        ? parseInt(quantityInput.dataset.salesIncrement, 10) || 0
        : 0;
      const ceiling =
        quantityInput && quantityInput.dataset.max
          ? parseInt(quantityInput.dataset.max, 10)
          : null;
      const quantity = window.roundUpToIncrement(
        rawQuantity,
        increment,
        ceiling,
      );

      if (quantity !== rawQuantity && quantityInput) {
        quantityInput.value = quantity;
        this.showRowNotice(
          quantityInput,
          window.cartStrings.salesIncrementAdjusted.replace(
            '[quantity]',
            quantity,
          ),
        );
      }

      items.push({
        id: formData.get('id'),
        quantity: String(quantity),
      });
    });

    if (items.length === 0) return;

    this.addToCart(items);
  }

  showRowNotice(quantityInput, message) {
    const notice = quantityInput
      .closest('td')
      ?.querySelector('[data-quantity-notice]');
    if (!notice) return;
    const text = notice.querySelector('.cart-item__error-text');
    if (text) text.textContent = message;
    notice.hidden = false;
  }

  addToCart(items) {
    this.disableSubmitting();
    const config = fetchConfig('javascript');
    config['body'] = JSON.stringify({ items, sections: 'cart-icon-bubble' });
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((data) => {
        this.successMessage.classList.remove(this.hiddenClass);
        this.updateQtyBubbleFromResponse(data);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setTimeout(() => {
          this.successMessage.classList.add(this.hiddenClass);
          this.submitButton.classList.remove('loading');
        }, 1500);
        this.enableSubmitting();
      });
  }

  updateQtyBubbleFromResponse(response) {
    const html = new DOMParser().parseFromString(
      response.sections['cart-icon-bubble'],
      'text/html',
    );
    const sourceQtyBubble = html.querySelector('.cart-count-bubble');

    this.qtyBubble.innerHTML = sourceQtyBubble.innerHTML;
  }

  disableSubmitting() {
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
  }

  enableSubmitting() {
    this.submitButton.setAttribute('aria-disabled', false);
    this.submitButton.classList.remove('loading');
  }
}
new AddMultipleProductsTable();
